import ForumPageTemplate from './ForumPageTemplate'

const LigeIIzazoviSinglePage = () => (
  <ForumPageTemplate
    title='LIGE I IZAZOVI'
    apiGetPath='betportal'
    apiPostPath='bet-portal-post'
    navigationPath='lige_i_izazovi'
    commentType='lige_i_izazovi'
    chatImagePath='betportal'
    enumType='leagues'
  />
)

export default LigeIIzazoviSinglePage
